<div class="solution-word-animation">
  <p #solutionContainer class="solution-word-hidden">
    <span #solutionHidden>{{solutionOriginal || solutionWord}}</span>
  </p>
  <p class="solution-word" [style.transform]="'scale(' + scaleValue + ')'"><span>{{solutionOutput}}</span></p>
</div>
